// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-tab-voice-banner {
  position: fixed;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999;
  background: rgba(24, 26, 38, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(245, 158, 11, 0.45);
  border-radius: 30px;
  padding: 8px 14px 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6), 0 0 20px rgba(245, 158, 11, 0.2);
  color: #f8fafc;
  font-size: 13px;
  font-weight: 600;
  pointer-events: auto;
  animation: slideDownToast 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  max-width: 90vw;
}

@keyframes slideDownToast {
  from {
    opacity: 0;
    transform: translate(-50%, -15px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

.mtvb-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mtvb-icon-wrap {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(245, 158, 11, 0.2);
  color: #f59e0b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mtvb-text {
  color: #f1f5f9;
  white-space: nowrap;
  letter-spacing: -0.01em;
}

.mtvb-close-btn {
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.mtvb-close-btn:hover {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  transform: scale(1.08);
}
`, "",{"version":3,"sources":["webpack://./src/components/MultiTabOverlay/MultiTabOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4EAA4E;EAC5E,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".multi-tab-voice-banner {\n  position: fixed;\n  top: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 999999;\n  background: rgba(24, 26, 38, 0.94);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(245, 158, 11, 0.45);\n  border-radius: 30px;\n  padding: 8px 14px 8px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6), 0 0 20px rgba(245, 158, 11, 0.2);\n  color: #f8fafc;\n  font-size: 13px;\n  font-weight: 600;\n  pointer-events: auto;\n  animation: slideDownToast 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  max-width: 90vw;\n}\n\n@keyframes slideDownToast {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -15px);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n.mtvb-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.mtvb-icon-wrap {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(245, 158, 11, 0.2);\n  color: #f59e0b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.mtvb-text {\n  color: #f1f5f9;\n  white-space: nowrap;\n  letter-spacing: -0.01em;\n}\n\n.mtvb-close-btn {\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.mtvb-close-btn:hover {\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  transform: scale(1.08);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
